import { motion } from 'framer-motion'

export const AnimatedSuggestionPlaceholder = ({ text }: { text: string }) => (
  <span
    className="pointer-events-none text-muted-foreground/60"
    aria-hidden
  >
    {text.split('').map((char, index) => (
      <motion.span
        key={`${text}-${index}`}
        initial={{ opacity: 0, x: -3 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{
          duration: 0.22,
          delay: index * 0.028,
          ease: 'easeOut',
        }}
      >
        {char === ' ' ? '\u00A0' : char}
      </motion.span>
    ))}
  </span>
)
